// extracted by mini-css-extract-plugin
export var container = "_49-0";
export var containerTopRight = "_49-1";